/**
 * Module Dependencies
 */

import './loader.css'
import React from 'react'

/**
 * Component
 */

import FinLogo from 'react/fin-logo'

/**
 * A placeholder component that
 * outlines the general app layout which
 * then get filled in on page load
 */

export const SplashLoader = (props) => {
  return (
    <div className='splash-loader' >
      <FinLogo animate={ false } message='' />
      <div id='tres-circle-loader-wrapper'>
        <div id='tres-circle-loader' />
      </div>
    </div>
  )
}

export default SplashLoader
